<template>
  <div class="diy-notifications">
    <transition-group name="translate-from-right">
      <NotificationBar
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
      />
    </transition-group>
  </div>
</template>

<script>
//Utilities
import { mapState } from 'vuex'
//Components
import NotificationBar from './NotificationBar.vue'

export default {
  name: 'AppNotifications',
  components: {
    NotificationBar,
  },
  computed: mapState('notifications', ['notifications']),
}
</script>

<style scoped>
.diy-notifications {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  bottom: 10px;
  right: 0;
  z-index: 300;
}
</style>
